/** Redux Reducers. */
import { addPresetNoteContent, updatePresetNoteContent } from 'shared/store/slices/presetNoteSlice';

export default function ApplySettingNoteHandler(props) {
    /** Get props from ApplySetting.js. */
    const { presetUIState, dispatch, presetNoteForm, dirtyFlags, setDirtyFlags, reduxDispatch } = props;

    /** Destructure state. */
    const { renderValue, selectedNote } = presetUIState;

    /** Handles updating selectedNote when a note category is selected by the user. */
    const handleNoteChip = (index, option) => {
        // Find note info from reducer state.
        const foundNote = presetNoteForm.find(
            (note) =>
                note.il_preset_id === renderValue.id && note.shipment_type === index && note.attribute === option.value
        );

        if (foundNote) {
            dispatch({
                type: 'SET_MULTIPLE',
                payload: {
                    selectedNote: {
                        index: index,
                        content: foundNote.value,
                        progress: { value: option.value, label: option.label },
                    },
                },
            });
        } else {
            dispatch({
                type: 'SET_MULTIPLE',
                payload: {
                    selectedNote: {
                        index: index,
                        content: '',
                        progress: { value: option.value, label: option.label },
                    },
                },
            });
        }
    };

    /**
     * Handler to update the preset note.
     * Finds the target note from Redux state and updates immediately (no debounce)
     * to ensure the latest content is always in Redux before the user clicks Save.
     */
    const handleNoteContent = (event) => {
        if (!dirtyFlags.isOriginDirty) setDirtyFlags((prev) => ({ ...prev, isOriginDirty: true }));

        dispatch({
            type: 'SET_MULTIPLE',
            payload: {
                selectedNote: {
                    ...selectedNote,
                    content: event.target.value,
                },
            },
        });

        const targetNote = presetNoteForm.find(
            (note) =>
                note.il_preset_id === renderValue.id &&
                note.shipment_type === selectedNote.index &&
                note.attribute === selectedNote.progress.value
        );

        if (targetNote) {
            reduxDispatch(updatePresetNoteContent({ ...targetNote, value: event.target.value }));
        } else {
            reduxDispatch(addPresetNoteContent({
                content: event.target.value,
                index: selectedNote.index,
                attribute: selectedNote.progress.value,
                preset_table_id: renderValue.id,
            }));
        }
    };

    return { handleNoteChip, handleNoteContent };
}
